export default "__VITE_ASSET__Cs8B93Dh__"